<template src="./EmployeesAndCreditRecharge.html" />

<script type="text/javascript" src="https://js.iugu.com/v2" />

<script>
import { useStore } from "@/store/store.js"
import mixins from "../../../../../Mixins.js"
import ExportReport from "@/components/export-report/ExportReport.vue"
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue"
import UpdateTableSize from "@/components/update-table-size/UpdateTableSize.vue"
import { reasonsList } from "@/constants/reasons-for-inativation"

export default {
  name: 'EmployeesAndCreditRecharge',
  mixins: [mixins],
  components: { WholeMultiselect, ExportReport, UpdateTableSize },
  data() {
    return {
      employees: [],
      taxEmployess: null,
      totalTaxEmployess: null,
      popupAlertPayTax: false,
      popupAlertPayTaxContent: {},
      popupCancel: false,
      inactiveDescription: "",
      employeeEnabled: null,
      description: null,
      reason: [],
      saveId: null,
      employeesExport: [],
      taxValues: [],
      showInputSamevalue: true,
      disabledInputValue: true,
      company: null,
      disabledButtonPayTax: true,
      newTaxCard: null,
      popupPayTax: false,
      checkboxBankSlip: false,
      checkboxCreditCard: false,
      employeesSelected: [
        {
          id: null,
          name: null,
          active: null,
          tax: 0,
          createDate: null,
          patientType: null,
          newUser: null,
        },
      ],
      uploadRegisters: {},
      validations: {},
      popupAlertRecharge: false,
      selected: [],
      currentx: 0,
      numPages: 0,
      pagination: false,
      windowWidth: 0,
      sortBy: "id",
      order: "desc",
      search: "",
      csvHistoric: {
        nome_empresa: "",
        id_empresa: "",
        id_funcionario: "",
        nome_funcionario: "",
        idade: "",
        email: "",
        cpf: "",
        telefone: "",
        cep: "",
        rua: "",
        numero: "",
        cidade: "",
        estado: "",
      },
      historicCsv: [],
      expirationMonth: null,
      expirationYear: null,
      cvcCreditCard: null,
      creditCardNumber: null,
      printedName: null,
      invalidFieldsPayTax: {
        name: false,
        nameCompany: false,
        cnpj: false,
        email: false,
        zipcode: false,
        street: false,
        number: false,
        creditCardNumber: false,
        cvcNumber: false,
        expirationMonth: false,
        expirationYear: false,
        time: false,
      },
      months: [
        { text: "Janeiro", value: 1 },
        { text: "Fevereiro", value: 2 },
        { text: "Março", value: 3 },
        { text: "Abril", value: 4 },
        { text: "Maio", value: 5 },
        { text: "Junho", value: 6 },
        { text: "Julho", value: 7 },
        { text: "Agosto", value: 8 },
        { text: "Setembro", value: 9 },
        { text: "Outubro", value: 10 },
        { text: "Novembro", value: 11 },
        { text: "Dezembro", value: 12 },
      ],
      time: [
        1 ,
        2 ,
        3 ,
        4 ,
        5 ,
        6 ,
        7 ,
        8 ,
        9 ,
        10 ,
      ],
      timeSelected: null,
      years: [
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
        "2031",
        "2032",
        "2033",
        "2034",
        "2035",
        "2036",
        "2037",
        "2038",
        "2039",
        "2040",
        "2041",
        "2042",
        "2043",
        "2044",
        "2045",
        "2046",
        "2047",
        "2048",
        "2049",
        "2050",
      ],
      tableSize: 10,
      searchUrl:"",
    };
  },
  computed: {
    isRequiredDescription() {
      return this.reason && this.reason.showReason
    },
    isButtonConfirmatioDisabled() {
      return !this.reason || !this.inactiveDescription && this.reason.requiredDescription
    }
  },
  watch: {
    checkboxBankSlip: function (newVal) {
      const vm = this;
      if (newVal == true) {
        vm.checkboxCreditCard = false;
        vm.printedName = null;
        vm.creditCardNumber = null;
        vm.cvcNumber = null;
        vm.expiringMonth = null;
        vm.expiringYear = null;
      }
    },
    checkboxCreditCard: function (newVal) {
      const vm = this;
      if (newVal == true) {
        vm.checkboxBankSlip = false;
      }
    },
    taxValues: function (newVal) {
      const vm = this;
      if (vm.testNullUndefinedEmpty(newVal) == false) {
        var total = vm.taxValues.reduce(function (total, numero) {
          if (numero == null) {
            numero = 0;
          }
          let num = parseFloat(numero);
          return total + num;
        }, 0);

        vm.totalTaxEmployess = total;
      }
    },
    taxEmployess: function (newVal) {
      const vm = this;
      vm.taxValues = [];
      if (vm.testNullUndefinedEmpty(newVal) == false) {
        for (let e in vm.employeesSelected) {
          vm.taxValues[e] = newVal;
          vm.totalTaxEmployess = vm.taxValues[e] * vm.employeesSelected.length;
        }
      }
    },
    selected: function () {
      const vm = this;
      if (vm.selected.length > 0) {
        vm.disabledButtonPayTax = false;
      } else {
        vm.disabledButtonPayTax = true;
      }
    },
    expirationMonth: function () {
      const vm = this;
      vm.invalidFieldsPayTax.expirationMonth = false;
    },
    expirationYear: function () {
      const vm = this;
      vm.invalidFieldsPayTax.expirationYear = false;
    },
    timeSelected: function () {
      const vm = this;
      vm.invalidFieldsPayTax.time = false;
    },
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
  },
  setup() {
    return {
      reasonsList: reasonsList.filter((reason) => reason.show)
    }
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  mounted: function () {
    const vm = this;
    vm.init();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  methods: {
    init() {
      const vm = this;
      if (vm.testNullUndefinedEmpty(vm.$route.params.id) === false) {
        vm.idCompany = vm.$route.params.id;
        vm.getCompany();
      }
    },
    getCompany() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer + "company/companies/" + vm.idCompany,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.company = response.data;
            vm.getEmployees();
          }
        });
    },
    getEmployeesExport() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "company/patients-to-download/" +
            vm.company.id,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.employeesExport = response.data;
          }
        });
    },
    getEmployees() {
      const vm = this;
      const page = vm.currentx - 1;
      vm.selected = [];
      vm.$vs.loading();
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "company/employees?page=" +
            page +
            "&search=" +
            vm.search +
            "&size=" + vm.tableSize + "&sort=" +
            vm.sortBy +
            "," +
            vm.order,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.employees = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            vm.$vs.loading.close();
          }
        })
        .catch(function () {
          vm.$vs.loading.close();
        });
    },
    saveInactivePatientHistory(){
      this.description = this.reason && this.reason.showReason
        ? `${this.reason.name}: ${this.inactiveDescription}`
        : this.reason.name

      this.axios.defaults.headers.common["Authorization"] = this.$session.get("bearer")

      this.axios.post(
        `${this.$store.state.filooServer}history-inactivate/inactivate`,
        { patientId: this.saveId, description: this.description }
      )
        .then((response) => {
          if (response.status === 200) {
          }
        })
        .catch(() => {})
    },
    changeStatusEmployee(employeeId) {
      const vm = this;
      vm.popupCancel = false;
      employeeId = vm.saveId;
      vm.selected = [];
      const inactivateClient = {
        id: this.saveId,
        reasonDeactivation: this.reason.name,
        descriptionDeactivation: this.inactiveDescription,
      }
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      vm.axios
        .put(vm.$store.state.filooServer + "company/changeStatus" , inactivateClient)
        .then(function (response) {
          if (response.status === 200) {
            vm.$swal(
              "Sucesso",
              "O status do paciente foi alterado com sucesso.",
              "success"
            );
            vm.getEmployees();
            vm.inactiveDescription = "";
            vm.description = null;
            vm.motivo = "";
          }
        })
        .catch(function () {
          vm.$swal(
            "Atenção",
            "Não foi possível realizar esta operação. Por favor contacte o administrador do sistema.",
            "error"
          );
        });
    },
    recharge() {
      const vm = this;
      vm.employeesSelected = [];
      vm.taxEmployess = null;
      vm.employeesSelected = vm.selected.map(function (elem) {
        return elem;
      });
      for (let e in vm.employeesSelected) {
        vm.taxValues[e] = null;
      }
      vm.selected = [];
      vm.popupAlertRecharge = true;
    },
    clickSameRechargeValue() {
      const vm = this;
      vm.taxEmployess = null;
      vm.totalTaxEmployess = null;
      vm.showInputSamevalue = true;
      vm.disabledInputValue = true;
      for (let e in vm.employeesSelected) {
        vm.taxValues[e] = null;
      }
    },
    clickCustomizeValue() {
      const vm = this;
      vm.taxEmployess = null;
      vm.totalTaxEmployess = null;
      vm.disabledInputValue = false;
      vm.showInputSamevalue = false;
      for (let e in vm.employeesSelected) {
        vm.taxValues[e] = null;
      }
    },
    payTax() {
      const vm = this;
      if (
        vm.testNullUndefinedEmpty(vm.totalTaxEmployess) ||
        vm.totalTaxEmployess < 10
      ) {
        vm.$vs.notify({
          title: "Atenção!",
          text: "Valor de recarga mínimo é de R$10,00",
          color: "warning",
          position: "top-right",
        });
      } else {
        vm.$vs.loading();

        let employeesId = vm.employeesSelected.map(function (elem, index) {
          return { id: elem.id, value: vm.taxValues[index] };
        });

        let requesPayload = {
          employees: employeesId,
          type: "REGISTER_RECHARGE",
          valueTotal: vm.totalTaxEmployess,
        };
        vm.axios
          .post(
            vm.$store.state.filooServer + "company/employees/charge",
            requesPayload,
            {
              headers: { Authorization: vm.$session.get("bearer") },
            }
          )
          .then(function (response) {
            if (response.status === 200) {
              vm.popupAlertPayTaxContent = response.data;
              vm.popupAlertRecharge = false;
              vm.companyUploadRegisters();
            }
          })
          .catch(function (error) {
            vm.$vs.loading.close();
            if (
              error.response.data.message ===
              "exception.payment.invalid.recharge.value"
            ) {
              vm.$vs.notify({
                title: "Atenção!",
                text: "Valor de recarga inválido ou insuficiente",
                color: "warning",
                position: "top-right",
              });
            } else {
              vm.$vs.notify({
                title: "Atenção!",
                text:
                  "Não foi possível completar essa socilitação, por favor contacte o administrador do sistema.",
                color: "warning",
                position: "top-right",
              });
            }
          });
      }
    },
    companyUploadRegisters() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "company/upload-registers/" +
            vm.popupAlertPayTaxContent.id,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.uploadRegisters = response.data;
            vm.popupAlertPayTax = true;
            vm.$vs.loading.close();
          }
        })
        .catch(function () {
          vm.$vs.loading.close();
        });
    },
    confirmOperation() {
      const vm = this;
      vm.popupAlertPayTax = false;
      vm.$vs.loading();
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "payment/upload-register/" +
            vm.popupAlertPayTaxContent.id +
            "/validations",
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.validations = response.data;
            vm.$vs.loading.close();
            vm.popupPayTax = true;
          }
        })
        .catch(function () {
          vm.$vs.loading.close();
        });
    },
    validateFieldsPayTax() {
      const vm = this;
      let valid = true;
      if (vm.checkboxBankSlip == false && vm.checkboxCreditCard == false) {
        vm.$vs.notify({
          title: "Atenção!",
          text: "Selecione uma forma de pagamento",
          color: "warning",
          position: "top-right",
        });
      } else {
        if (vm.checkboxCreditCard == true) {
          if (vm.validateCreditCardNumber(vm.creditCardNumber) == false) {
            vm.invalidFieldsPayTax.creditCardNumber = true;
            valid = false;
          }
          if (vm.testNullUndefinedEmpty(vm.printedName)) {
            vm.invalidFieldsPayTax.printedName = true;
            valid = false;
          } else if (vm.testFullName(vm.printedName) == false) {
            vm.invalidFieldsPayTax.printedName = true;
            valid = false;
          }
          if (vm.testNullUndefinedEmpty(vm.cvcCreditCard)) {
            vm.invalidFieldsPayTax.cvcNumber = true;
            valid = false;
          } else if (vm.cvcCreditCard.length < 3) {
            vm.invalidFieldsPayTax.cvcNumber = true;
            valid = false;
          }
          if (vm.testNullUndefinedEmpty(vm.expirationMonth)) {
            vm.invalidFieldsPayTax.expirationMonth = true;
            valid = false;
          }
          if (vm.testNullUndefinedEmpty(vm.expirationYear)) {
            vm.invalidFieldsPayTax.expirationYear = true;
            valid = false;
          }
          if (vm.testNullUndefinedEmpty(vm.timeSelected)) {
            vm.invalidFieldsPayTax.time = true;
            valid = false;
          }
        }
        if (vm.checkboxBankSlip == true) {
          if (vm.testNullUndefinedEmpty(vm.company.name)) {
            vm.invalidFieldsPayTax.nameCompany = true;
            valid = false;
          }
          if (vm.validateCNPJ(vm.company.cnpj) == false) {
            vm.invalidFieldsPayTax.cnpj = true;
            valid = false;
          }
          if (vm.validateEmail(vm.company.email) == false) {
            vm.invalidFieldsPayTax.email = true;
            valid = false;
          }
          if (/^[0-9]{5}-[0-9]{3}$/.test(vm.company.address.zipcode) == false) {
            vm.invalidFieldsPayTax.zipcode = true;
            valid = false;
          }
          if (vm.testNullUndefinedEmpty(vm.company.address.street)) {
            vm.invalidFieldsPayTax.street = true;
            valid = false;
          }
          if (vm.testNullUndefinedEmpty(vm.company.address.number)) {
            vm.invalidFieldsPayTax.number = true;
            valid = false;
          }
        }
      }
      if (valid === true) {
        if (vm.checkboxBankSlip == true) {
          vm.finalizeBankSlipPayament();
        } else if (vm.checkboxCreditCard == true) {
          vm.initIUGUProcess();
        }
      }
    },
    finalizeBankSlipPayament() {
      const vm = this;
      let requesPayload = {
        description: "RECHARGE",
        method: "bank_slip",
        email: vm.company.email,
        payer: {
          name: vm.company.name,
          cpf_cnpj: vm.company.cnpj.replace(/[^\d]+/g, ""),
          address: vm.company.address,
        },
        upload_register_id: vm.popupAlertPayTaxContent.id,
      };
      vm.axios
        .post(vm.$store.state.filooServer + "payment/charge", requesPayload, {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function (response) {
          if (response.status === 200) {
            let url = response.data.invoice_url_pdf;
            window.open(url, "_blank");
            vm.popupPayTax = false;
            vm.$swal(
              "Sucesso",
              "Boleto gerado com sucesso, o prazo para compensação do boleto é de até 3 dias úteis.",
              "success"
            ).then(function () {
              vm.$emit("clickShowEmployeeReport", event);
            });
          }
        })
        .catch(function () {
          vm.popupPayTax = false;
          vm.$swal(
            "Atenção",
            "Não foi possível realizar esta operação. Por favor contacte o administrador do sistema.",
            "error"
          );
        });
    },
    initIUGUProcess() {
      const vm = this;
      let creditCardNumber = vm.creditCardNumber.replace(/[^\d]+/g, "");

      let nameArray = vm.printedName.split(" ");
      let firstName = nameArray[0];
      nameArray.splice(0, 1);
      let lastName = nameArray.join(" ");
      vm.initIUGU();
      Iugu.CreditCard();

      let iuguCreditCard = Iugu.CreditCard(
        creditCardNumber,
        vm.expirationMonth.value.toString(),
        vm.expirationYear,
        firstName,
        lastName,
        vm.cvcCreditCard
      );

      if (iuguCreditCard.valid()) {
        Iugu.createPaymentToken(iuguCreditCard.toData(), function (response) {
          if (response && response.id) {
            vm.finalizeCreditCardPayment(response.id);
          } else {
            vm.$swal(
              "Ops!",
              "Erro ao validar cartão! Gostaria de utilizar outro cartão ou pagar com boleto?",
              "error"
            );
          }
        });
      }
    },
    finalizeCreditCardPayment(token) {
      const vm = this;
      let requesPayload = {
        description: "RECHARGE",
        method: "credit_card",
        email: vm.company.email,
        token: token,
        months: vm.timeSelected,
        upload_register_id: vm.popupAlertPayTaxContent.id,
      };
      vm.axios
        .post(vm.$store.state.filooServer + "payment/charge", requesPayload, {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function (response) {
          if (response.status === 200) {
            if (
              response.data.status == "Transação negada" ||
              response.data.status == "Cartão inválido"
            ) {
              vm.$vs.notify({
                title: "Atenção!",
                text:
                  "Não foi possível realizar esta operação. A transão foi negada pela operadora, verique os dados digitados e tente novamente ou utilize outro cartão. Caso o problema persista por favor contacte o administrador do sistema.",
                color: "danger",
                time: 8500,
                position: "top-right",
              });
            } else {
              vm.popupPayTax = false;
              vm.$swal(
                "Sucesso",
                "Pagamento realizado com sucesso.",
                "success"
              ).then(function () {
                vm.$emit("clickShowEmployeeReport", event);
              });
            }
          }
        })
        .catch(function () {
          vm.$swal(
            "Atenção",
            "Não foi possível realizar esta operação. Por favor contacte o administrador do sistema.",
            "error"
          );
        });
    },
    initIUGU() {
      Iugu.setAccountID("01F2C1AD387143F5BBFC8FBD20EAD02A");
      Iugu.setup();
      Iugu.setTestMode(this.$store.state.filooIuguTest);
    },
    async getAddressData(zipcode) {
      this.invalidFields.zipcode = false
      this.invalidFields.number = false
      this.invalidFields.street = false
      this.invalidFields.state = false
      this.invalidFields.city = false

      if (zipcode && /^[0-9]{5}-[0-9]{3}$/.test(zipcode)) {
        const response = await this.getAddressByZipcode(zipcode)

        if (response && response.address) {
          this.company.address.city = response.address.city
          this.company.address.state = response.address.state
          this.company.address.street = response.address.street
        }
      }
    },
    changePagination() {
      const vm = this;
      vm.getEmployees();
    },
    handleSort(key, active) {
      const vm = this;
      vm.sortBy = key;
      if (active === true) {
        vm.order = "desc";
      } else {
        vm.order = "asc";
      }
      vm.getEmployees();
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },

    updateTableSize(size) {
      const vm = this;
      vm.tableSize = size;
      vm.currentx = 1;
      vm.getEmployees();
    },

    changeSearch(){
      const vm = this;
      vm.searchUrl = vm.testNullUndefinedEmpty(vm.search)? "": "&search=" + vm.search;
      vm.currentx = 1;
      vm.getEmployees();
    },
  },
};
</script>

<style lang="scss" src="./EmployeesAndCreditRecharge.scss" />
